import axios, { AxiosResponse } from "axios";

interface RequestOptions {
  headers?: Record<string, string>;
  body?: any;
}

async function request(
  url: string,
  method: string,
  options?: RequestOptions
): Promise<Response> {
  const headers = {
    ...options?.headers,
    Authorization: `Bearer `,
    "Content-Type": "application/json",
  };

  const config: RequestInit = {
    method,
    headers: headers,
    body: options?.body ? JSON.stringify(options.body) : undefined,
  };

  return await fetch(url, config);
}

export async function post(
  url: string,
  data: any,
  options?: RequestOptions
): Promise<Response> {
  return request(url, "POST", {
    ...options,
    body: data,
  });
}

export async function get(
  url: string,
  options?: RequestOptions
): Promise<Response> {
  return request(url, "GET", options);
}

export async function del(
  url: string,
  options?: RequestOptions
): Promise<Response> {
  return request(url, "DELETE", options);
}

export async function patch(
  url: string,
  data: any,
  options?: RequestOptions
): Promise<Response> {
  return request(url, "PATCH", {
    ...options,
    body: data,
  });
}

export async function axiospost(
  url: string,
  body?: any
): Promise<AxiosResponse> {
  return await axios.post(url, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
